export default __webpack_public_path__ + "assets/images/0c2f4871345302914e90c55e5c7336cf.svg";